import {useAdministrationOrganizationStore} from "@/stores/administration/organization-store";
import {useAuthStore} from "@/stores/authentication-store";

const routesToReload = ["organizations-list"];

export const organizationProvisionPageReload = (route: string | null | undefined) => {
    if (!route || !routesToReload.includes(route)) return;

    setTimeout(async () => {
        window.location.reload();
    }, 1000);
}

export const refreshOrganizations = async () => {
    const organizationStore = useAdministrationOrganizationStore();
    const authStore = useAuthStore();

    if (!authStore.hasClaims(["administration-organizations.update"])) return;

    await organizationStore.fetchOrganizations();
}
